@use "../zr-theme/zr-variables.scss" as *;
@use "../zr-css-icon/zr-css-icon.scss" as i;
@use "../zr-theme/functions/fonts" as f;

// local component name
$component: 'zr-rating-badge';

:host {
    --rating-star-size: 25px;
    --rating-text-size: 14px;
    line-height: 0;
    height: 24px;
    display: inline-block;
}

.#{$component}__wrapper {
    padding: 4px 0;
    display: flex;
    align-items: center;
    font-size: var(--rating-text-size);
    color: var(--ci-neutral800);
    font-weight: 600;
    cursor: pointer;

    p {
        margin-bottom: 0;
    }
}

.#{$component}__icon {
    @include i.get-icon-only(star-gold);

    &::before {
        background-color: #FA9600;
    }
}

.#{$component}__active-star {
    &::before {
        height: 16px;
        width: 16px;
    }

    &:active {
        opacity: 0.2;
    }
}

// Spacer if no rating. To prevent layout shift
.#{$component}--spacer {
    height: 24px;
    width: 2px;
}

// media query: tablet and above
@media only screen and (min-width: $tablet-screen) {
    .#{$component} {
        align-items: center;
        font-weight: 600;
    }

    .#{$component}__active-star {
        cursor: pointer;

        &::before {
            height: var(--rating-star-size);
            width: var(--rating-star-size);
        }
    }
}
